// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles for draggable decoration */
table.draggable {
	margin-left: -10px;
	margin-top: -10px;
}

table.draggable:hover > tbody > tr > td.draggable-table,
table.draggable:hover > tbody > tr > td.draggable-column,
table.draggable:hover > tbody > tr > td.draggable-row {
	background-color: var(--ds-background-neutral-bold, #777);
	border-top: 1px solid var(--ds-border, #777);
	border-left: 1px solid var(--ds-border, #777);
}

table.draggable:hover > tbody > tr > td.draggable-table,
table.draggable:hover > tbody > tr > td.draggable-column {
	border-right: 1px solid var(--ds-border-bold, #aaa);
}

table.draggable:hover > tbody > tr > td.draggable-table,
table.draggable:hover > tbody > tr > td.draggable-row {
	border-bottom: 1px solid var(--ds-border-bold, #aaa);
}

td.draggable-table,
td.draggable-column,
td.draggable-row {
	background-color: transparent;
	border-top: 1px solid transparent;
	border-left: 1px solid transparent;
	cursor: move;
}

td.draggable-table,
td.draggable-column {
	border-right: 1px solid transparent;
}

td.draggable-table,
td.draggable-row {
	border-bottom: 1px solid transparent;
}

td.draggable-column {
	height: 10px;
}

td.draggable-row {
	width: 10px;
}

/*.detached {*/
/*position: absolute;*/
/*}*/

.wiki-content img.confluence-embedded-image,
.wiki-content img.editor-inline-macro,
.wiki-content table.wysiwyg-macro {
	cursor: pointer !important;
}

.wiki-content table.wysiwyg-macro > tbody > tr > td.wysiwyg-macro-body {
	cursor: text;
}

#move-indicator {
	font-weight: normal !important;
}
`, "",{"version":3,"sources":["webpack://./../confluence-editor/src/editor-plugins/draggable/draggable.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;CACC,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;;;CAGC,yDAAyD;CACzD,4CAA4C;CAC5C,6CAA6C;AAC9C;;AAEA;;CAEC,mDAAmD;AACpD;;AAEA;;CAEC,oDAAoD;AACrD;;AAEA;;;CAGC,6BAA6B;CAC7B,iCAAiC;CACjC,kCAAkC;CAClC,YAAY;AACb;;AAEA;;CAEC,mCAAmC;AACpC;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,WAAW;AACZ;;AAEA,cAAc;AACd,sBAAsB;AACtB,IAAI;;AAEJ;;;CAGC,0BAA0B;AAC3B;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,8BAA8B;AAC/B","sourcesContent":["/* Styles for draggable decoration */\ntable.draggable {\n\tmargin-left: -10px;\n\tmargin-top: -10px;\n}\n\ntable.draggable:hover > tbody > tr > td.draggable-table,\ntable.draggable:hover > tbody > tr > td.draggable-column,\ntable.draggable:hover > tbody > tr > td.draggable-row {\n\tbackground-color: var(--ds-background-neutral-bold, #777);\n\tborder-top: 1px solid var(--ds-border, #777);\n\tborder-left: 1px solid var(--ds-border, #777);\n}\n\ntable.draggable:hover > tbody > tr > td.draggable-table,\ntable.draggable:hover > tbody > tr > td.draggable-column {\n\tborder-right: 1px solid var(--ds-border-bold, #aaa);\n}\n\ntable.draggable:hover > tbody > tr > td.draggable-table,\ntable.draggable:hover > tbody > tr > td.draggable-row {\n\tborder-bottom: 1px solid var(--ds-border-bold, #aaa);\n}\n\ntd.draggable-table,\ntd.draggable-column,\ntd.draggable-row {\n\tbackground-color: transparent;\n\tborder-top: 1px solid transparent;\n\tborder-left: 1px solid transparent;\n\tcursor: move;\n}\n\ntd.draggable-table,\ntd.draggable-column {\n\tborder-right: 1px solid transparent;\n}\n\ntd.draggable-table,\ntd.draggable-row {\n\tborder-bottom: 1px solid transparent;\n}\n\ntd.draggable-column {\n\theight: 10px;\n}\n\ntd.draggable-row {\n\twidth: 10px;\n}\n\n/*.detached {*/\n/*position: absolute;*/\n/*}*/\n\n.wiki-content img.confluence-embedded-image,\n.wiki-content img.editor-inline-macro,\n.wiki-content table.wysiwyg-macro {\n\tcursor: pointer !important;\n}\n\n.wiki-content table.wysiwyg-macro > tbody > tr > td.wysiwyg-macro-body {\n\tcursor: text;\n}\n\n#move-indicator {\n\tfont-weight: normal !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
